import { breakpoints } from "@tvg/design-system";
import styled from "styled-components";

export const Container = styled.div<{ isFloating: boolean }>`
  background-color: var(--fd-colors-racing-betslip-selections-background);
  border-radius: ${({ isFloating }) =>
    isFloating
      ? "var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020) 0 0"
      : 0};
  height: 44px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  z-index: 100;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 12px;
    z-index: 10;
  }

  &::before {
    left: 0;
    background-image: linear-gradient(
      to right,
      var(--fd-colors-racing-betslip-selections-background),
      rgb(255 255 255 / 0%)
    );
  }

  &::after {
    right: 100px;
    background-image: linear-gradient(
      to left,
      var(--fd-colors-racing-betslip-selections-background),
      rgb(255 255 255 / 0%)
    );
  }

  /* stylelint-disable media-query-no-invalid */
  @media screen and ${breakpoints.tablet.max.sm} {
    &::after {
      right: 0;
    }

    border-radius: 0;
  }
`;
